import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m4.97 6.03 3.487 3.487 1.06-1.06L6.031 4.97l3.486-3.486-1.06-1.06L4.97 3.91 1.485.424.424 1.484 3.91 4.97.424 8.456l1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }